import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CatalogMetadata } from 'src/app/catalogs/models/catalog-metadata.model';

/**
 * Generates the default tooltip string from metadata properties.
 * This is a pure function that takes metadata and returns a string.
 */
@Component({
  selector: 'app-catalog-metadata-icon',
  template: `@if (metadata) {
    <i
      class="pi pi-info-circle text-blue-400 cursor-help"
      [title]="getTooltip()">
    </i>
  }`,
  styles: [],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CatalogMetadataIconComponent {
  @Input() metadata: CatalogMetadata | null = null;
 
  getTooltip(): string {
    if (!this.metadata) {
      return 'No metadata available';
    }
    
    if (typeof (this.metadata as any).toTooltip === 'function') {
      return (this.metadata as any).toTooltip();
    }
    
    return null;
  }
}